// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-be4b5daa]{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:100%;height:48px;padding:12px;background-color:#2e180b;border-radius:10px;cursor:pointer;color:#fff;margin-top:10px;font-size:16px}.btn__label[data-v-be4b5daa]{margin:0 6px}.btn__label__highlight[data-v-be4b5daa]{padding:0 10px;background-color:#f7ba0a;color:#000;border-radius:50vh}", ""]);
// Exports
module.exports = exports;
